exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userGroupManagementTagsWrapper{gap:35px;display:flex;justify-content:center}@media screen and (max-width:1080px){.userGroupManagementTagsWrapper{display:block}}.userGroupManagementTagsWrapper table td,.userGroupManagementTagsWrapper table th{font-size:.75rem}.userGroupManagementTagsWrapper table .tableId{width:10%}.userGroupManagementTagsWrapper table .tableName{width:40%}.userGroupManagementTagsWrapper table .tableCreate,.userGroupManagementTagsWrapper table .tableLinks{width:25%}", ""]);

// exports
